<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <vehiculos-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm" class="" @click="modelos(data.item)" v-b-tooltip.hover.top="'Modelos'" variant="flat-info">
              <feather-icon icon="BoxIcon" />
            </b-button>
            <b-button size="sm" class="" @click.prevent="edit(data.item)" v-b-tooltip.hover.top="'Editar'" variant="flat-success">
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" @click="deleteAction(data)" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import vehiculosFilters from './vehiculosFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VehicleService from '@/services/VehicleService'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data(){
    return{
      showLoading: false,
      records: [],
      fields: [
        //{ key: 'id', label: 'ID', sortable: true },
        { key: 'name', label: 'Nombre', sortable: false },
        { key: 'updated_at', label: 'Fecha de creación', sortable: false,
          formatter: (value) => {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return new Date(value).toLocaleDateString(undefined, options);
          }
        },
        { key: 'actions', label: 'Acciones' }
      ],
      form:{
        id: null,
        name: ''
      },
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'asc',
    }
  },
  components:{
    vehiculosFilters
  },
  mounted(){
    this.getData()
  },
  methods:{
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    modelos(data){
      this.$router.push('/vehiculos/' + data.id + '/modelos')
    },
    edit(item){
      this.form.id = item.id
      this.form.name = item.name
      this.$refs.filters.isAdd = true
      this.$refs.filters.$children[0].getData(this.form)
    },
    async getData(){
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await VehicleService.getAutoPartsVehicle(url, this.$store)
      if (resp.data.rows.length != 0) {
        this.records = resp.data.rows
        this.totalElements = resp.data.rows.length
      }
      this.showLoading = false
    },
    async deleteAction(data) {
      this.$swal({
        title: '¿Desea eliminar este vehiculo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminalo',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1
          this.$swal({
            icon: 'success',
            title: 'Eliminado!',
            text: 'El vehiculo ha sido eliminado.',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
          this.deleteData(data.item.id)
        }
      })
    },
    async deleteData(id) {
      const resp = await VehicleService.deleteAutoPartVehicle(id, this.$store)
      if (resp) {
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al eliminar el vehiculo.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
    },
  }
}
</script>

<style>

</style>
